import { Backdrop, CircularProgress, styled } from '@mui/material';
import { ultraMarine } from '../utils/colors';

const StyledBackdrop = styled(Backdrop)({
  color: ultraMarine['500'],
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
});

export default function LoadingBackdrop() {
  return (
    <StyledBackdrop open sx={(theme) => ({ zIndex: theme.zIndex.modal + 1 })}>
      <CircularProgress color="inherit" />
    </StyledBackdrop>
  );
}
